// Банер сверху AppShell, виден только когда активен View-as (TZ §5.11).
// Показывает: «Вы смотрите как X (роль)» + кнопку «Выйти из режима».
// Цвет специально яркий (orange) — Создатель должен явно осознавать, что он
// видит UI чужими глазами и любые действия будут ОТ ЛИЦА выбранного юзера.

import { Group, Text, Button, Box } from '@mantine/core';
import { IconUserExclamation, IconLogout2 } from '@tabler/icons-react';
import { useNavigate } from 'react-router-dom';
import { notifications } from '@mantine/notifications';
import { useAuth } from '../auth/AuthContext.jsx';
import { ApiError } from '../api/client.js';
import { ROLE_META } from '../utils/format.js';

export function ActingAsBanner() {
    const { actingAs, user, realUser, exitActingAs } = useAuth();
    const navigate = useNavigate();

    if (!actingAs || !user) return null;

    const handleExit = async () => {
        try {
            await exitActingAs();
            // Возвращаем Создателя на главную — оттуда уже HomePage редиректит
            // по его роли (на /tenants).
            navigate('/', { replace: true });
            notifications.show({
                color: 'blue',
                title: 'Вы вышли из режима «Войти как»',
                message: realUser?.fullName
                    ? `Снова работаете как ${realUser.fullName}`
                    : 'Снова работаете под собственной учётной записью',
            });
        } catch (err) {
            notifications.show({
                color: 'red',
                title: 'Не удалось выйти из режима',
                message: err instanceof ApiError ? err.message : 'Ошибка сервера',
            });
        }
    };

    const targetMeta = ROLE_META[user.role] || { label: user.role, color: 'gray' };
    const targetLabel = user.fullName || user.username;

    return (
        <Box
            bg="orange.6"
            c="white"
            px="md"
            py={6}
            style={{
                position: 'sticky',
                top: 0,
                zIndex: 1000,
                borderBottom: '1px solid var(--mantine-color-orange-7)',
            }}
        >
            <Group justify="space-between" wrap="nowrap" gap="md">
                <Group gap="xs" wrap="nowrap" style={{ minWidth: 0 }}>
                    <IconUserExclamation size={18} style={{ flexShrink: 0 }} />
                    <Text size="sm" fw={500} style={{ minWidth: 0 }}>
                        Режим «Войти как»: вы видите UI как{' '}
                        <strong>{targetLabel}</strong> ({targetMeta.label})
                        {realUser && (
                            <>
                                {' '}
                                · реальный аккаунт:{' '}
                                <strong>{realUser.fullName || realUser.username}</strong>
                            </>
                        )}
                    </Text>
                </Group>
                <Button
                    size="xs"
                    color="dark"
                    variant="white"
                    leftSection={<IconLogout2 size={14} />}
                    onClick={handleExit}
                    style={{ flexShrink: 0 }}
                >
                    Выйти из режима
                </Button>
            </Group>
        </Box>
    );
}
